
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@environment';
import { TranslateService } from '@ngx-translate/core';
import { DownloadService } from '../../lib';
import { map } from 'rxjs';

export type DocumentationType = 'general' | 'internal';

@Injectable({
    providedIn: 'root',
})
export class DocumentationViewerService {

    private readonly http: HttpClient = inject(HttpClient);
    private readonly environment = inject(ENVIRONMENT);
    readonly translate = inject(TranslateService);
    readonly downloadService = inject(DownloadService);

    private path: string = `${this.environment.apiUrl}Documentation/`;


    loadMarkdown(type: DocumentationType) {
        let params = { lang: this.translate.getCurrentLang()! }
        return this.http.get<string>(`${this.path}/${type}`, { params })
    }

    downloadPdf(type: DocumentationType, completeCallback?: (() => void)) {

        let params = { lang: this.translate.getCurrentLang()! }
        let fileName: string = (() => {
            const lang = this.translate.getCurrentLang() ?? 'en';
            return `documentation-${type}-${lang}.pdf`;
        })();

        return this.downloadService.downloadFile(`${this.path}/${type}/pdf`, params, fileName, completeCallback);
    }

    loadResource(type: DocumentationType, src: string) {
        return this.http
            .get(`${this.path}/${type}/${src}`, {
                responseType: 'blob',
                observe: 'response',
            })
            .pipe(map((res) => res.body));
    }

}
